const PropertyType = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.96865 6.93746C2.33166 6.93746 0.999878 5.60568 0.999878 3.96865C0.999878 2.33162 2.33166 0.999878 3.96865 0.999878C5.60564 0.999878 6.93742 2.33166 6.93742 3.96865C6.93742 5.60564 5.60568 6.93746 3.96865 6.93746ZM3.96865 2.24988C3.02087 2.24988 2.24988 3.02087 2.24988 3.96865C2.24988 4.91642 3.02087 5.68742 3.96865 5.68742C4.91642 5.68742 5.68742 4.91642 5.68742 3.96865C5.68742 3.02087 4.91642 2.24988 3.96865 2.24988Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M18.0312 6.93745H11.1469C9.50984 6.93745 8.1781 5.60568 8.1781 3.96869C8.1781 2.3317 9.50984 0.999878 11.1469 0.999878H18.0312C19.6683 0.999878 21 2.33166 21 3.96865C21 5.60564 19.6682 6.93745 18.0312 6.93745ZM11.1469 2.24988C10.1991 2.24988 9.4281 3.02087 9.4281 3.96865C9.4281 4.91642 10.1991 5.68741 11.1469 5.68741H18.0312C18.979 5.68741 19.75 4.91642 19.75 3.96865C19.75 3.02087 18.979 2.24988 18.0312 2.24988H11.1469Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M3.96865 13.9688C2.33166 13.9688 0.999878 12.637 0.999878 11C0.999878 9.36296 2.33166 8.03122 3.96865 8.03122C5.60564 8.03122 6.93741 9.363 6.93741 11C6.93741 12.637 5.60568 13.9688 3.96865 13.9688ZM3.96865 9.28122C3.02087 9.28122 2.24988 10.0522 2.24988 11C2.24988 11.9478 3.02087 12.7188 3.96865 12.7188C4.91642 12.7188 5.68741 11.9478 5.68741 11C5.68741 10.0522 4.91642 9.28122 3.96865 9.28122Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M18.0312 13.9688H11.1469C9.50984 13.9688 8.1781 12.637 8.1781 11C8.1781 9.363 9.50988 8.03122 11.1469 8.03122H18.0312C19.6683 8.03122 21 9.363 21 11C21 12.637 19.6682 13.9688 18.0312 13.9688ZM11.1469 9.28118C10.1991 9.28118 9.4281 10.0522 9.4281 11C9.4281 11.9477 10.1991 12.7187 11.1469 12.7187H18.0312C18.979 12.7187 19.75 11.9477 19.75 11C19.75 10.0522 18.979 9.28118 18.0312 9.28118H11.1469Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M3.96865 21.0001C2.33166 21.0001 0.999878 19.6683 0.999878 18.0313C0.999878 16.3943 2.33166 15.0625 3.96865 15.0625C5.60564 15.0625 6.93741 16.3943 6.93741 18.0313C6.93741 19.6683 5.60568 21.0001 3.96865 21.0001ZM3.96865 16.3125C3.02087 16.3125 2.24988 17.0835 2.24988 18.0313C2.24988 18.979 3.02087 19.75 3.96865 19.75C4.91642 19.75 5.68741 18.979 5.68741 18.0313C5.68741 17.0835 4.91642 16.3125 3.96865 16.3125Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M18.0312 21.0001H11.1469C9.50984 21.0001 8.1781 19.6683 8.1781 18.0313C8.1781 16.3943 9.50988 15.0625 11.1469 15.0625H18.0312C19.6683 15.0625 21 16.3943 21 18.0313C21 19.6683 19.6682 21.0001 18.0312 21.0001ZM11.1469 16.3125C10.1991 16.3125 9.4281 17.0835 9.4281 18.0313C9.4281 18.979 10.1991 19.75 11.1469 19.75H18.0312C18.979 19.75 19.75 18.979 19.75 18.0313C19.75 17.0835 18.979 16.3125 18.0312 16.3125H11.1469Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default PropertyType;
